import { render, staticRenderFns } from "./content.vue?vue&type=template&id=06056646&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=06056646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06056646",
  null
  
)

export default component.exports